<template>
  <div
    class="toast-modal-header mx-4 pt-6 pb-3 mb-3 border-b-1 border-solid relative border-neutral-200 text-center text-neutral-800"
    :class="{ 'pt-10': showCloseButton }"
  >
    <button
      v-if="showCloseButton"
      class="toast-modal-header-close-button appearance-none"
      :aria-label="$t('Accessibilty.AriaLabels.CloseModal')"
      tabindex="0"
      @click="$emit('close')"
    >
      <OSvg svg="close" class="z-10 fill-neutral-400" />
    </button>
    <span class="o-heading-3" v-text="title" />
  </div>
</template>

<script>
import OSvg from '@/components/OSvg'

export default {
  name: 'ToastModalheader',
  components: {
    OSvg
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    showCloseButton: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="postcss" scoped>
.toast-modal-header {
  &-close-button {
    cursor: pointer;
    position: absolute;
    top: 0.4rem;
    right: -0.8rem;
  }
}

@screen lg {
  .toast-modal-header {
    &-close-button {
      top: 0.4rem;
      right: -1.8rem;
    }
  }
}
</style>
